import React from 'react';

import ModalHeader from '@components/modals/ModalHeader/ModalHeader';
import Button from '@components/uikit/Button/Button';

import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import { useUserResetPasswordMutation } from '@services/user/useUserResetPasswordMutation';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

const ResetPasswordModal = ({ userInfo }) => {
  const { t } = useTranslation();
  const { setModalClose } = useModalActions();

  const { mutate: userResetPasswordMutate } = useUserResetPasswordMutation();

  const handleConfirm = () =>
    userResetPasswordMutate(
      { type: 'byEmail', userId: userInfo.id },
      {
        onSuccess: () => {
          showToast({
            variant: 'success',
            message: t('An email with a password reset has been sent to the selected user.'),
          });
          handleClose();
        },
      },
    );

  const handleClose = () => {
    setModalClose();
  };

  return (
    <div className={style.modalResetPassByEmail}>
      <ModalHeader />
      <div className={style.modalHeadSeparator}>
        <div className={style.modalHeadSeparatorMark} />
      </div>
      <div className={style.modalBody}>
        <div className={style.modalBodyTitle}>{t('Reset Password by email')}</div>
        <div className={style.modalBodyDescription}>
          {t('An email containing a reset link will be sent to this email address.')}
        </div>
        <div className={style.modalBodyEmailInfo}>
          <div className={style.userInfo}>
            <div>{userInfo?.fullName}</div>
            <p>{userInfo?.email}</p>
          </div>
        </div>
      </div>
      <div className={style.modalFooter}>
        <Button
          type="primary"
          disabled={!userInfo?.email}
          text={t('Send reset link')}
          onClick={handleConfirm}
        />
        <Button type="secondary" text={t('Cancel')} onClick={handleClose} />
      </div>
    </div>
  );
};

export default ResetPasswordModal;
